import type { Feature, GeoJsonProperties, Geometry } from 'geojson'
import { useMemo } from 'react'
import type { LayerProps } from 'react-map-gl'
import { Layer, Source } from 'react-map-gl'
import { aClient, aMapStyle, aMapViewState, useAtomValue } from '~/atoms'

export default function ClientPolygonLayer() {
  const client = useAtomValue(aClient)
  const mapStyle = useAtomValue(aMapStyle)
  const viewState = useAtomValue(aMapViewState)

  const layerStyle: LayerProps = {
    type: 'line',
    source: 'geographies',
    paint: {
      'line-color': '#000',
      'line-opacity': 0.15,
    },
  }

  const clientGeomLayerStyle = useMemo(() => {
    const baseOpacity = mapStyle === 'street' ? 0.13 : 0.23
    // view state will always be defined here, but fixing typing
    const opacity = viewState ? baseOpacity - (viewState!.zoom! / 18) * 0.1 : 0
    const style: LayerProps = {
      id: 'data',
      type: 'fill',
      paint: {
        'fill-color': mapStyle === 'street' ? '#000' : '#fff',
        'fill-opacity': opacity,
      },
    }
    return style
  }, [viewState, mapStyle])

  const geojson: Feature<Geometry, GeoJsonProperties> | null = useMemo(() => {
    if (!client!.geom) {
      return null
    }
    return client!.geom as unknown as Feature<Geometry, GeoJsonProperties>
  }, [client])

  const isState =
    client!.find &&
    'property.state_abbr' in client!.find! &&
    Object.keys(client!.find).length === 1

  if (geojson === null || viewState === null || isState) {
    return null
  }

  return (
    <Source type="geojson" data={geojson}>
      <Layer beforeId="z-index-1" {...layerStyle} />
      <Layer beforeId="z-index-1" {...clientGeomLayerStyle} />
    </Source>
  )
}
